import axios from "../api/axios";
import {PROCESS_ORDER_URL} from "../utils/constants";

export async function processOrder(data: any): Promise<any> {
    const response = await axios.post(PROCESS_ORDER_URL, data);
    return response.data;
}
